import React, { useEffect } from 'react';
import GTMUtility from 'app/util/gtmUtil';

import {
  Box,
  Button,
  Stack,
  Typography,
} from '@mui/material';

import ListingShape from 'app/shapes/ListingShape';
import useFlirtActions from 'app/hooks/useFlirtActions';
import Disconnected from 'app/components/call/callInProgress/Icons/Disconnected';

const DeclinedBySeekerStep = ({
  listing,
}) => {
  useEffect(() => {
    GTMUtility.sendEvent('call_declined_by_seeker_step', { version: 'redesign' });
  }, []);

  const { onTributeButtonClick } = useFlirtActions({ advisor: { id: listing.advisor_id, login: listing.login } });

  return (
    <Box textAlign="center">
      <Typography variant="h3">
        Your call has ended.
      </Typography>
      <Box mt={3} mb={3}>
        <Disconnected />
      </Box>
      <Typography variant="body1" gutterBottom>
        We hope you enjoyed your call.
      </Typography>
      <Box mt={4} mb={3}>
        <Button
          id="call-now-send-tribute-button-from-declined-by-seeker"
          color="primary"
          variant="contained"
          size="large"
          onClick={onTributeButtonClick}
          sx={{ width: { xs: '95%', sm: '260px' } }}
        >
          Send Tribute
        </Button>
      </Box>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ mt: 2 }}
      >
        <a href={listing.listing_category_path}>
          <Button
            id="call-now-find-a-flirt-from-declined-by-seeker"
            variant="outlined"
            size="medium"
          >
            Find a Flirt
          </Button>
        </a>
      </Stack>
    </Box>
  );
};

DeclinedBySeekerStep.defaultProps = {
};

DeclinedBySeekerStep.propTypes = {
  listing: ListingShape.isRequired,
};

export default DeclinedBySeekerStep;
